import React from 'react';

export default function Background({ size, url, opacity }) {
  const style = {}
  style.backgroundImage = url
		? (style.backgroundImage = `url(${url})`)
		: 'url("./assets/images/passion_musique_fonds-baguette.png")'
  if (size)
    style.backgroundSize = `${size}px auto`
  style.opacity = opacity ?? 0.72
  return (
      <div className='bg-img' style={style} ></div>
  )
}
